const initialState = {
	active: false,
	isLockedWorkstation: false,
	isNotifiedWorkstation: false
};

const eventLookups = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case "DURESS_STATUS_RECEIVED": {
			return payload;
		}
		default:
			return state;
	}
};

export default eventLookups;
